exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sub-el-icon[data-v-74203d80] {\n  color: currentColor;\n  width: 1em;\n  height: 1em;\n}\n", ""]);

// exports
